<style lang="scss">
.calls {
}
</style>

<!-- eslint-disable -->
<template>
  <div class="theme-color-wrapper p-2 wings-page">
    <div class="calls row">
      <div class="col-12">
        <section class="d-flex align-items-center sm-row-drop mb-sm-2">
          <h2 cy="page-title" class="font-weight-bolder mb-sm-0 mb-2">Wings</h2>
          <div class="ui-spacer"></div>
          <b-btn @click="showModal('modal-add', true)" class="sm-full-width mb-sm-0 mb-2" variant="success">Create Wing</b-btn>
        </section>

        <p class="mb-2" v-if="!loading">{{getWingTerminalCount()}}/{{prison.terminal_count}} Terminals Allotted</p>

        <section v-if="!loading">
          <b-table
            class="data-table mx-0 px-0" cy="wings-table"
            hover
            :items="wings"
            :fields="columns"
            :current-page="currentPage"
            :per-page="perPage"
            :responsive="true"
          >
            <template #cell(actions)="data">
              <b-dropdown class="m-0" variant="link" right toggle-class="text-decoration-none" no-caret>
                <template #button-content>
                  <i class="fas fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item-button class="full-nested-btn"
                                        @click="showModal('modal-edit', true, data.item)">
                  Edit
                </b-dropdown-item-button>
                <b-dropdown-item-button class="full-nested-btn"
                                        @click="showModal('modal-stock', true, data.item)">
                  Set Stock
                </b-dropdown-item-button>
              </b-dropdown>
            </template>
          </b-table>
          <b-row>
            <b-col md="6" class="my-1" v-if="wings.length > 0">
              <b-pagination :total-rows="wings.length" :per-page="perPage" v-model="currentPage" class="my-0"/>
            </b-col>
            <p v-else>No Wings</p>
          </b-row>
        </section>

        <b-spinner class="d-block" v-else variant="primary"></b-spinner>
      </div>
    </div>

    <b-modal id="modal-add" hide-footer>
      <wings-add @close="closeAllModalAndRefresh"></wings-add>
    </b-modal>

    <b-modal id="modal-edit" hide-footer>
      <wings-edit v-if="activeItem" :existing-wing="activeItem" @close="closeAllModalAndRefresh"></wings-edit>
    </b-modal>

    <b-modal id="modal-stock" hide-footer>
      <wings-set-stock v-if="activeItem" :existing-wing="activeItem" @close="closeAllModalAndRefresh"></wings-set-stock>
    </b-modal>
  </div>
</template>
<!-- eslint-enable -->

<script>
import {mapState} from 'vuex';
import WingService from '@/services/WingService';
import WingsAdd from '@/views/wings/WingsAdd';
import WingsEdit from '@/views/wings/WingsEdit';
import WingsSetStock from '@/views/wings/WingsSetStock';

export default {
  name: 'Wings',
  components: {
    WingsAdd,
    WingsEdit,
    WingsSetStock,
  },
  props: {},
  data() {
    return {
      loading: true,
      activeItem: null,
      wings: [],
      columns: [
        {key: 'name', label: 'Name',},
        {key: 'terminal_stock', label: 'terminal stock',},
        {key: 'status', label: 'status',},
        {key: 'actions', label: 'Actions',},
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      prison: state => state.prison.prison,
    }),
  },
  async mounted() {
    await this.$store.dispatch('prison/getPrison');
    this.getWings();
  },
  methods: {
    getWings() {
      WingService.getWings().then(res => {
        let items = res.data || [];

        // Order kiosk items
        this.wings = items.sort((a, b) => { // sort alphabetically
          return a.name.localeCompare(b.name);
        });
      }).catch(err => {
        this.$toast.error('Error getting wings, please check your connection and refresh the page', {
          toastClassName: ['toast-std', 'warning-toast'],
        });
      }).finally(() => {
        this.loading = false;
      });
    },
    showModal(name, value, item = null) {
      this.activeItem = item;
      if (value) {
        this.$bvModal.show(name);
      } else {
        this.$bvModal.hide(name);
      }
    },
    closeAllModalAndRefresh(refreshPrison = false) {
      this.$bvModal.hide('modal-stock');
      this.$bvModal.hide('modal-add');
      this.$bvModal.hide('modal-edit');
      this.getWings();

      if (refreshPrison) {
        this.$store.dispatch('prison/getPrison', true);
      }
    },
    getWingTerminalCount() {
      return this.wings.filter((wing) => wing.status === 'Enabled').reduce((terminalCount, wing) => terminalCount + wing.terminal_stock, 0);
    },
  },
}
</script>
